import { BaseEntityLineChart } from '../../../components/Charts';
import { useTop149Chart } from '../hooks/useTop149Chart';
import { useAppSelector } from '../../../store/hooks';

interface Top149ChartProps {
	height?: number;
	yearsAchieveTop149?: number;
}

export function Top149Chart({ height = 400, yearsAchieveTop149 }: Top149ChartProps) {
	const selectedFaculty = useAppSelector((state) => state.filters.selectedFaculty);

	const { nivoData, isLoading, error } = useTop149Chart({
		filters: {
			maKhoa: selectedFaculty ? [selectedFaculty] : undefined
		},
		yearsAchieveTop149,
	});

	return (
		<BaseEntityLineChart
			height={height}
			title="Biểu đồ Sinh viên theo Trường Top 149"
			downloadFilename="bieu-do-top149"
			entityLabel="Chọn trường"
			entityPlaceholder="Tất cả trường"
			groupByEntity
			nivoData={nivoData}
			isLoading={isLoading}
			error={error}
		/>
	);
}
